"use client";

import { defaultLocale, isLocale, type Locale } from "@/lib/i18n/locales";
import { localizedPath } from "@/lib/i18n/navigation";
import NextLink from "next/link";
import { useParams } from "next/navigation";
import type { ComponentProps } from "react";
import { forwardRef } from "react";

type NextLinkProps = ComponentProps<typeof NextLink>;

function skipLocalize(href: string): boolean {
  if (href.startsWith("http://") || href.startsWith("https://")) return true;
  if (href.startsWith("mailto:") || href.startsWith("tel:")) return true;
  if (href.startsWith("/downloads")) return true;
  if (href.startsWith("#")) return true;
  return false;
}

function useRouteLocale(): Locale {
  const params = useParams();
  const raw = params?.locale;
  const s = Array.isArray(raw) ? raw[0] : raw;
  return isLocale(s) ? s : defaultLocale;
}

export const SLLink = forwardRef<HTMLAnchorElement, NextLinkProps>(
  function SLLink({ href, ...rest }, ref) {
    const locale = useRouteLocale();

    if (typeof href === "string") {
      if (!skipLocalize(href)) {
        return (
          <NextLink ref={ref} href={localizedPath(href, locale)} {...rest} />
        );
      }
      return <NextLink ref={ref} href={href} {...rest} />;
    }

    return <NextLink ref={ref} href={href} {...rest} />;
  },
);
